import React from "react";
import { Card, Form, Icon, Message, Dimmer, Loader, Button } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";

const dateTimePicker = event => {
  return {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    minDate: event.start_at,
    maxDate: event.end_at
  }
};

const disableDeleteIfOnlyOnePPData = (pricepoints, i, lastPPTablet, lastPPWeb, length) => {
    let disabledTablet = false;
    let disableWeb = false;

    let arrayTablet = pricepoints.filter(function (el) {
      return el['type'] === 'tablet' && el != null;
    });

    let arrayWeb = pricepoints.filter(function (el) {
      return el['type'] === 'web' && el != null;
    });

    if (lastPPWeb.length > 0 && arrayWeb.length === 1) {
      if (arrayWeb[0]['ppId'] === i + length) {
        disableWeb = true;
      }
    }

    if (lastPPTablet.length > 0 && arrayTablet.length === 1) {
      if (arrayTablet[0]['ppId'] === i) {
        disabledTablet = true;
      }
   }

   return {
     disabledTablet: disabledTablet,
     disableWeb: disableWeb
   }
}

const DynamicDates = props => {
  let pricepointsFieldName = `pricingData.dynamic.${props.index}.pricepoints`;
  let flag = false;
  let name = pricepointsFieldName.split('.');
  if (props.pricing['dynamic'].length !== props.dynamicLength && +name[2] !== props.dynamicLength - 1 && +name[2] > props.dynamicLength - 1) {
    flag = true;
  }
  return <Card>
    <Card.Content>
      <h4>Dynamic Pricing</h4>
      <Form.Field>
        <label>
          <Icon name="calendar" /> Start Time
        </label>
        <Flatpickr
          name={`pricingData.dynamic.${props.index}.start`}
          value={props.pricing["dynamic"][props.index].start || ""}
          options={dateTimePicker(props.values)}
          onChange={(_, str, b) =>
            props.handleChange(b.element, {
              name: `pricingData.dynamic.${props.index}.start`,
              value: str
            })
          }
        />
      </Form.Field>
      <Form.Field>
        <label>
          <Icon name="calendar" /> End Time
        </label>
        <Flatpickr
          name={`pricingData.dynamic.${props.index}.end`}
          value={props.pricing["dynamic"][props.index].end || ""}
          options={dateTimePicker(props.values)}
          onChange={(_, str, b) =>
            props.handleChange(b.element, {
              name: `pricingData.dynamic.${props.index}.end`,
              value: str
            })
          }
        />
      </Form.Field>
      <Form.Button
        type="button"
        secondary
        onClick={() => props.removePrice(props.index)}
        disabled={props.eventId && !flag}
      >
        Delete
      </Form.Button>
    </Card.Content>
  </Card>
};

const PricingCard = props => {
  let pricepointsFieldName = `pricingData.default`;
  let pricepoints = props.pricing["default"];
  let length = props.maxPricePointCount;
  let subscriptionEnabled = props.subscriptionEnabled;
  let group = [];
  // Outer loop to create parent
  for (let i = 1; i <= length; i++) {
    let disabled = disableDeleteIfOnlyOnePPData(pricepoints, i, props.lastPPData.lastPPTablet, props.lastPPData.lastPPWeb, length)
    group.push(
      <Form.Group key={i} className="pricingCardGroup">
        <Form.Button
          type="button"
          label={i === 1 ? "Delete" : false}
          icon={!pricepoints[length * props.count + (i - 1)] ? "add" : "delete"}
          size="mini"
          color={!pricepoints[length * props.count + (i - 1)] ? "green" : "red"}
          onClick={() => props.deletePricepoint(i - 1, props.device)}
          id={props.device === "web" ? `delete_${i + length}` : `delete_${i}`}
          className="pricingCardGroupBtn"
          disabled={(!props.values.is_first_thread || !props.isPPEditable) || (props.device === "web" ? disabled.disableWeb : disabled.disabledTablet)}
        />
        {pricepoints[length * props.count + (i - 1)] &&
          <Form.Input
            type="number"
            min="0"
            label={i === 1 ? "Quantity" : false}
            name={pricepointsFieldName + `.${length * props.count + (i - 1)}.quantity`}
            value={
              pricepoints[length * props.count + (i - 1)].quantity
            }
            placeholder="# of tickets"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={!props.values.is_first_thread || !props.isPPEditable}
            id={pricepointsFieldName + `.${props.device}.${i - 1}.quantity`}
            error={isNaN(pricepoints[length * props.count + (i - 1)].quantity)}
          />
        }
        {pricepoints[length * props.count + (i - 1)] &&
          <Form.Input
            type="number"
            min="0"
            label={i === 1 ? "Price" : false}
            name={pricepointsFieldName + `.${length * props.count + (i - 1)}.price`}
            value={
              pricepoints[length * props.count + (i - 1)].price
            }
            placeholder="0.00"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={!props.values.is_first_thread || !props.isPPEditable}
            id={pricepointsFieldName + `.${props.device}.${i - 1}.price`}
            error={isNaN(pricepoints[length * props.count + (i - 1)].price)}
          />
        }
        {pricepoints[length * props.count + (i - 1)] && +props.pricepointLimitsEnabled > 0 && (
          <Form.Input
            type="number"
            min="0"
            label={i === 1 ? "Limit" : false}
            name={pricepointsFieldName + `.${length * props.count + (i - 1)}.maxCount`}
            defaultValue={
              pricepoints[length * props.count + (i - 1)].maxCount
            }
            placeholder="0"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={!props.values.is_first_thread || !props.isPPEditable}
            id={pricepointsFieldName + `.${props.device}.${i - 1}.maxCount`}
          />
        )}
        {pricepoints[length * props.count + (i - 1)] && +props.pricepointLabelsEnabled > 0 && (
          <Form.Input
            label={i === 1 ? "Label" : false}
            name={pricepointsFieldName + `.${length * props.count + (i - 1)}.label`}
            defaultValue={
              pricepoints[length * props.count + (i - 1)].label
            }
            maxLength="3"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={!props.values.is_first_thread || !props.isPPEditable}
            id={pricepointsFieldName + `.${props.device}.${i - 1}.label`}
          />
        )}
        {pricepoints[length * props.count + (i - 1)] &&
          <Form.Field disabled={!props.values.is_first_thread || !props.isPPEditable} id={pricepointsFieldName + `.${props.device}.${i - 1}.highlight`}>
            {i === 1 && (<label><strong>Highlight</strong></label>)}
            <Form.Radio
              toggle
              name={pricepointsFieldName + `.${length * props.count + (i - 1)}.highlight`}
              value={pricepoints[length * props.count + (i - 1)].highlight === 1 ? 1 : 0}
              defaultChecked={pricepoints[length * props.count + (i - 1)] && pricepoints[length * props.count + (i - 1)].highlight === 1}
              onChange={props.handleChange}
              className="radioToggleBtn pricePointHighlightToggleBtn"
            />
          </Form.Field>
        }
        {pricepoints[length * props.count + (i - 1)] && props.device == "web" && subscriptionEnabled && props.values.event_subscription_group_id > 0 && (
         <Form.Field disabled={!props.values.is_first_thread || !props.isPPEditable}>
            {i === 1 && (<label><strong>Subscription</strong></label>)}
            <Form.Radio
              toggle
              name={pricepointsFieldName + `.${length * props.count + (i - 1)}.subscription`}
              value={pricepoints[length * props.count + (i - 1)].subscription === 1 ? 1 : 0}
              defaultChecked={pricepoints[length * props.count + (i - 1)] && pricepoints[length * props.count + (i - 1)].subscription === 1}
              onChange={props.handleChange}
              className="radioToggleBtn pricePointSubscriptionToggleBtn"
            />
          </Form.Field>
        )}
      </Form.Group>
    );
  }
  return (
    <Card>
      <Card.Content>
        <h4>
          <Icon
            name={props.device === "tablet" ? "tablet alternate" : "globe"}
          />
          {props.title} Pricing
        </h4>
        {group}
      </Card.Content>
    </Card>
  );
};

// Dynamic Card
const PricingCardDynamic = props => {
  let pricepointsFieldName = `pricingData.dynamic.${props.index}.pricepoints`;
  let pricepoints = props.pricing["dynamic"][props.index]["pricepoints"];
  let pricePointCount = props.maxPricePointCount;
  let group = [];
  let flag = false;
  let name = pricepointsFieldName.split('.');
  if (props.pricing['dynamic'].length !== props.dynamicLength && +name[2] !== props.dynamicLength - 1 && +name[2] > props.dynamicLength - 1) {
    flag = true;
  }
  const count = pricepoints[0]?.type === 'web' ? 0 : props.count;
  // Outer loop to create parent
  for (let i = 1; i <= pricePointCount; i++) {
    let pricePointIndex = pricePointCount * count + (i - 1);
    let disabled = disableDeleteIfOnlyOnePPData(pricepoints, i, props.lastPPData.lastDynamicPPTablet, props.lastPPData.lastDynamicPPWeb, pricePointCount)

    group.push(
      <Form.Group key={i} className="pricingCardGroup">
        <Form.Button
          type="button"
          label={i === 1 ? "Delete" : false}
          size="mini"
          onClick={() => props.deletePricepointSet(props.index, i - 1, props.device)}
          disabled={(props.eventId && !flag) || (props.device === "web" ? disabled.disabledWeb : disabled.disabledTablet)}
          id={props.device === "web" ? `delete_dynamic_${props.index}_${i + pricePointCount}` : `delete_dynamic_${props.index}_${i}`}
          icon={!pricepoints[pricePointIndex] ? "add" : "delete"}
          color={!pricepoints[pricePointIndex] ? "green" : "red"}
          className="pricingCardGroupBtn"
        />
        {pricepoints[pricePointIndex] &&
          <Form.Input
            type="number"
            min="0"
            label={i === 1 ? "Quantity" : false}
            name={pricepointsFieldName + `.${pricePointIndex}.quantity`}
            value={
              pricepoints[pricePointIndex].quantity
            }
            placeholder="# of tickets"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={props.eventId && !flag}
            id={pricepointsFieldName + `.${pricePointIndex}.quantity`}
            error={isNaN(pricepoints[pricePointIndex].quantity)}
          />
        }
        {pricepoints[pricePointIndex] &&
          <Form.Input
            type="number"
            min="0"
            label={i === 1 ? "Price" : false}
            name={pricepointsFieldName + `.${pricePointIndex}.price`}
            value={
              pricepoints[pricePointIndex].price
            }
            placeholder="0.00"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={props.eventId && !flag}
            id={pricepointsFieldName + `.${pricePointIndex}.price`}
            error={isNaN(pricepoints[pricePointIndex].price)}
          />
        }
        {pricepoints[pricePointIndex] && +props.pricepointLimitsEnabled > 0 && (
          <Form.Input
            type="number"
            min="0"
            label={i === 1 ? "Limit" : false}
            name={pricepointsFieldName + `.${pricePointIndex}.maxCount`}
            defaultValue={
              pricepoints[pricePointIndex].maxCount
            }
            placeholder="0"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={props.eventId && !flag}
            id={pricepointsFieldName + `.${pricePointIndex}.maxCount`}
          />
        )}
        {pricepoints[pricePointIndex] && +props.pricepointLabelsEnabled > 0 && (
          <Form.Input
            label={i === 1 ? "Label" : false}
            name={pricepointsFieldName + `.${pricePointIndex}.label`}
            defaultValue={
              pricepoints[pricePointIndex].label
            }
            maxLength="3"
            width={8}
            onChange={props.handleChange}
            className="pricingCardInput"
            disabled={props.eventId && !flag}
            id={pricepointsFieldName + `.${pricePointIndex}.label`}
          />
        )}
        {pricepoints[pricePointIndex] &&
          <Form.Field id={pricepointsFieldName + `.${pricePointIndex}.highlight`} disabled={props.eventId && !flag}>
            {i === 1 && (<label><strong>Highlight</strong></label>)}
            <Form.Radio
              toggle
              name={pricepointsFieldName + `.${pricePointIndex}.highlight`}
              value={pricepoints[pricePointIndex].highlight === 1 ? 1 : 0
              }
              defaultChecked={pricepoints[pricePointIndex].highlight === 1}
              onChange={props.handleChange}
              className="radioToggleBtn"
            />
          </Form.Field>
        }

      </Form.Group>
    );
  }

  return (
    <Card>
      <Card.Content>
        <h4>
          <Icon
            name={props.device === "tablet" ? "tablet alternate" : "globe"}
          />
          {props.title} Pricing
        </h4>
        {group}
      </Card.Content>
    </Card>
  );
};

function Pricing(props) {
  const {
    valid,
    values,
    pricepointLimitsEnabled,
    pricingData,
    isPPEditable,
    dynamicResponseArrayLength,
    eventId,
    customWebPricingEnabled,
    pricepointLabelsEnabled,
    dynamicPricingEnabled,
    subscriptionEnabled,
    errorMaxTickets,
    lastPPData,
    eventFormValidationMessage,
    hasOneValidDefaultPrice } = props;
    let rules = {
      "validateQuantity": "required|min:1",
      "validatePrice": "required|min:1",
      "validateDynamicQuantity": "required",
      "validateDynamicPrice": "required"
    };
    const customMessages = {
      "required.validateQuantity": "Quantity must not be empty",
      "min.validateQuantity": "Invalid quantity",
      "required.validatePrice": "Price must not be empty",
      "min.validatePrice": "Invalid price",
      "required.validateDynamicQuantity": "Quantity must not be empty",
      "required.validateDynamicPrice": "Price must not be empty"
    };
    if (values.id > 0 || hasOneValidDefaultPrice){
        rules["validateQuantity"] = "required";
        rules["validatePrice"] = "required";
    }
    props.setRules(rules, customMessages);
    let pricingCardDisplayFlag = true;
    let pricingCardTitleFlag = false;
    if (+values.webenabled > 0 || +values.shopify_enabled > 0) {
      pricingCardDisplayFlag = +customWebPricingEnabled === 0 ? false : true;
      pricingCardTitleFlag = +customWebPricingEnabled === 0 ? true : false;
    } else {
      pricingCardDisplayFlag = false;
    }
  return (
    <Form size="small" error={valid.errorCount > 0}>
      <Message
        error
        content={Object.keys(valid.errors.all()).map((item, key) => {
          return (
            <span key={key}>
              {valid.errors.first(item)}
              <br />
            </span>
          );
        })}
      />
      {errorMaxTickets !== "" && <Message
        error
        content={errorMaxTickets}
        visible={errorMaxTickets !== ""}
      />}
      {eventFormValidationMessage !== "" && <Message
        error
        content={eventFormValidationMessage}
        visible={eventFormValidationMessage !== ""}
      />}
      {pricingData['default'] ?
        <Card.Group key={`pricingDefault`} className="uiCardGroup">
          {(values.rsu_enabled || !customWebPricingEnabled) && (
            <PricingCard
              key={"tablet"}
              name={"default"}
              device={"tablet"}
              title={pricingCardTitleFlag ? "Tablet & Web" : "Tablet"}
              count={values.rsu_enabled ? 0 : 1}
              pricing={pricingData}
              pricepointLimitsEnabled={pricepointLimitsEnabled}
              maxPricePointCount={props.maxPricePointCount}
              handleChange={props.handleChange}
              isPPEditable={isPPEditable}
              deletePricepoint={props.deletePricepoint}
              pricepointLabelsEnabled={pricepointLabelsEnabled}
              lastPPData={lastPPData}
              values={props.values}
            />
          )}
          {pricingCardDisplayFlag && (
            <PricingCard
              key={"web"}
              name={"default"}
              device={"web"}
              title={"Web"}
              count={1}
              pricing={pricingData}
              pricepointLimitsEnabled={pricepointLimitsEnabled}
              maxPricePointCount={props.maxPricePointCount}
              subscriptionEnabled={props.subscriptionEnabled}
              handleChange={props.handleChange}
              isPPEditable={isPPEditable}
              deletePricepoint={props.deletePricepoint}
              pricepointLabelsEnabled={pricepointLabelsEnabled}
              lastPPData={lastPPData}
              values={props.values}
            />
          )}
        </Card.Group> :
        <Dimmer active inverted>
          <Loader inverted>
            Loading
          </Loader>
        </Dimmer>
      }
      {+dynamicPricingEnabled > 0 && Date.parse(values.end_at) > Date.now() &&
        <Form.Button primary type="button" onClick={props.addPrice} className="pricingCardInput addPricingButton">
          Add Pricing
        </Form.Button>
      }
      {pricingData['dynamic'] ? Object.keys(pricingData).map((value, index) => (
        value === "dynamic" && pricingData[value].map((v, k) =>
          <Card.Group key={`pricing${k}`} className="uiCardGroup">
            <DynamicDates
              key={"dates" + k}
              name={value}
              index={k}
              pricing={pricingData}
              removePrice={props.removePrice}
              handleChange={props.handleChange}
              dynamicLength={dynamicResponseArrayLength}
              eventId={eventId}
              values={props.values}
            />
            {(values.rsu_enabled || !customWebPricingEnabled) && (
              <PricingCardDynamic
                key={"tablet" + k}
                name={value}
                index={k}
                count={values.rsu_enabled ? 0 : 1}
                device={"tablet"}
                title={pricingCardTitleFlag ? "Tablet & Web" : "Tablet"}
                pricing={pricingData}
                pricepointLimitsEnabled={pricepointLimitsEnabled}
                maxPricePointCount={props.maxPricePointCount}
                handleChange={props.handleChange}
                dynamicLength={dynamicResponseArrayLength}
                deletePricepointSet={props.deletePricepointSet}
                eventId={eventId}
                isPPEditable={isPPEditable}
                pricepointLabelsEnabled={pricepointLabelsEnabled}
                lastPPData={lastPPData}
                values={props.values}
              />
            )}
            {pricingCardDisplayFlag && (
              <PricingCardDynamic
                key={"web" + k}
                name={value}
                index={k}
                count={1}
                device={"web"}
                title={"Web"}
                pricing={pricingData}
                pricepointLimitsEnabled={pricepointLimitsEnabled}
                maxPricePointCount={props.maxPricePointCount}
                handleChange={props.handleChange}
                dynamicLength={dynamicResponseArrayLength}
                deletePricepointSet={props.deletePricepointSet}
                eventId={eventId}
                isPPEditable={isPPEditable}
                pricepointLabelsEnabled={pricepointLabelsEnabled}
                lastPPData={lastPPData}
                values={props.values}
              />
            )}
          </Card.Group>
        ))) :
        <Dimmer active inverted>
          <Loader inverted>
            Loading
          </Loader>
        </Dimmer>
      }
      <input
        name="event.validateQuantity"
        id="validateQuantityPricingInput"
        defaultValue={values.validateQuantity}
      ></input>
      <input
        name="event.validatePrice"
        id="validatePricePricingInput"
        defaultValue={values.validatePrice}
      ></input>
      <input
        name="event.validateDynamicQuantity"
        id="validateDynamicQuantityPricingInput"
        defaultValue={values.validateDynamicQuantity}
      ></input>
      <input
        name="event.validateDynamicPrice"
        id="validateDynamicPricePricingInput"
        defaultValue={values.validateDynamicPrice}
      ></input>
      <br />
      <Button
        type="button"
        primary
        size="large"
        content="Save And Continue"
        onClick={() => props.handleStep("jackpot")}
        floated="right"
      />
      <Button
        type="button"
        size="large"
        content="Go Back"
        onClick={() => props.handleStep("sales")}
        floated="right"
      />

    </Form>
  );
}

export default Pricing;
